import styled from 'styled-components';
import {theme} from '@styles/theme';

export const TooltipWrapper = styled.div<{displayOnTop: boolean}>`
  position: absolute;
  background: ${theme.colors.basic01};
  border-radius: ${theme.roundedMedium};
  padding: 8px;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
  z-index: 99;
  ${({displayOnTop}) =>
    !displayOnTop
      ? `top: calc(100% + 12px);
         &:after {
           content: '';
           position: absolute;
           top: -11px;
           left: 50%;
           transform: translateX(-50%);
           width: 20px;
           height: 12px;
           background-image: url('/assets/icons/tooltipArrow.svg');
         }`
      : `bottom: calc(100% + 12px);
         &:before {
           content: '';
           position: absolute;
           bottom: -11px;
           left: 50%;
           transform: translateX(-50%) rotate(180deg);
           width: 20px;
           height: 12px;
           background-image: url('/assets/icons/tooltipArrow.svg');
         }
      `};
`;
